module.exports = __webpack_public_path__ + "img/detail_img.d7811ef2.png";